import { render, staticRenderFns } from "./VmHolders.vue?vue&type=template&id=5b5a9688&scoped=true"
import script from "./VmHolders.vue?vue&type=script&lang=js"
export * from "./VmHolders.vue?vue&type=script&lang=js"
import style0 from "./VmHolders.vue?vue&type=style&index=0&id=5b5a9688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a9688",
  null
  
)

export default component.exports